import { defineComponent as _defineComponent } from 'vue'
import { ref,watch,onMounted } from "vue";
import { useAuth } from "@/store/auth";
import Loader from "@/components/loader.vue";
type PageState = "sign-in" | "create-account" | "logged-in";


export default /*#__PURE__*/_defineComponent({
  __name: 'auth',
  setup(__props, { expose: __expose }) {
  __expose();

const auth = useAuth();
const pageState = ref<PageState>("sign-in")

const loading = ref<boolean>(false);

const from = ref<string>("")

const email = ref<string>("")
const password = ref<string>("")
const confirmPass = ref<string>("");

const emailFocused = ref<boolean>(false);
const passwordFocused = ref<boolean>(false);
const confirmPassFocused = ref<boolean>(false);

const error = ref<string | null>(null);


async function doLogin(){
	loading.value = true;
	try{
		error.value = null;
		const result = await auth.signIn(email.value, password.value);

		if(result.success){
			if(from.value !== ""){
				if(from.value === 'map'){
					//window.location.href = `https://alscrowd.org/`
					window.location.href = `https://alscrowd.busystaging.com/`
				}else if(from.value === 'database'){
					//window.location.href = 'https://alscrowd.org/database-table/#'
					window.location.href = 'https://alscrowd.busystaging.com/database-table/#'
				}
			}else{
				//window.location.href = `https://alscrowd.org/`
				window.location.href = `https://alscrowd.busystaging.com/`
			}
		}else{
			//console.log("sign in failed:", result.reason);
			error.value = result.reason ? result.reason : null;
		}
	}catch(e){
		error.value = "Unknown error"
	}finally{
		loading.value = false;
		setTimeout(()=>{
			error.value = null
		},4000)
	}
};

async function doSignup(){
	loading.value = true;
	if(password.value === confirmPass.value){
		try{
			const result = await auth.createUser(email.value, password.value);
			if(result.success){
				//console.log("sign up successful")
				if(from.value !== ""){
					if(from.value === 'map'){
						//window.location.href = `https://alscrowd.org/`
						window.location.href = `https://alscrowd.busystaging.com/`
					}else if(from.value === 'database'){
						//window.location.href = 'https://alscrowd.org/database-table/#'
						window.location.href = 'https://alscrowd.busystaging.com/database-table/#'
					}
				}else{
					//window.location.href = `https://alscrowd.org/`
					window.location.href = `https://alscrowd.busystaging.com/`
				}
			}else{
				error.value = result.reason ? result.reason : null;
			}
		}catch(e){
			error.value = "Unknown error"
			console.error(e);
		}finally{
			setTimeout(()=>{
				error.value = null
			},4000)
		}

	}else{
		error.value = "Passwords don't match"
		setTimeout(()=>{
			error.value = null
		},4000)
	}
	loading.value = false;
}

async function doLogout(){
	loading.value = true;
	await auth.signOut();
	loading.value = false;
}

watch(()=> auth.user, ()=>{
	if(auth.user){
		pageState.value = 'logged-in'
	}else{
		pageState.value = 'sign-in';
	}
});

onMounted(()=>{
	const hashValue = window.location.hash.substring(1);
	if(hashValue){
		const decodedHash = decodeURIComponent(hashValue);
		from.value = decodedHash;
	}
})

const __returned__ = { auth, pageState, loading, from, email, password, confirmPass, emailFocused, passwordFocused, confirmPassFocused, error, doLogin, doSignup, doLogout, ref, watch, onMounted, get useAuth() { return useAuth }, Loader }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})